<template>
  <div class="gwd-inline-row gwd-align gwd-jd-rank" :class="additionalClass" :style="`margin-top: ${mt}px`">
    <img :src="(location.hostname.includes('bijiago') ? '/bjg': '') + `/images/rank/jdranklabel.svg`" alt="" style="width: 72px; height: 18px;">
    <div class="gwd-rank-list gwd-row gwd-align" :class="data.length > 1 ? 'gwd-rotate': ''" style="position: relative">
      <a :title="data[0].rname" :href="data[0].rurl" target="_blank" class="gwd-row gwd-align gwd-rank-first" ><span class="font12">
        <span class="gwd-mw">{{ data[0].rname }}</span><span v-if="data[0].rank">第{{data[0].rank}}名</span>
      </span></a>
      <div v-if="data.length > 1" class="gwd-rank-addition">
        <a :title="item.rname" v-for="item in addition" :key="item.rurl" :href="item.rurl" target="_blank">
          <span class="font12 gwd-mw">{{ item.rname }}</span>
        </a>
      </div>
    </div>
  </div>
</template>
<style scoped lang="less">
@import "../css/common";

.gwd-jd-rank {
  width: 232px;
  height: 32px;
  background: url(https://cdn.gwdang.com/images/extensions/jdRanking/ranklistBg.svg);

  .gwd-icon-rank {
    width: 15px;
    height: 15px;
    margin-left: 5px;
  }

  .gwd-vline {
    display: block;
    width: 1px;
    height: 10px;
    background: #000000;
    margin-left: 0px;
    border: 0;
  }

  .gwd-rank-list {
    flex: 1;
    height: 100%;
    a {
      padding-left: 7px;
      flex: 1;
      span {
        display: inline-block;
        transform-origin: left center;
        color: #111111;
        white-space: nowrap;
        overflow: hidden;
        vertical-align: middle;
        text-overflow: ellipsis;
      }
      span.gwd-mw {
        max-width: 120px;
      }
    }

    a:hover {
      span {
        color: #e03024;
        font-weight: bold;
      }
    }

    .gwd-rank-first {
      span {
        color: #e03024;
      }
    }

    .gwd-rank-addition {
      display: none;
      position: absolute;
      right: 0;
      width: 153px;
      top: 100%;
      border: 1px solid #fbefef;
      overflow: hidden;
      background: white;
      z-index: 9;
      a {
        height: 25px;
        line-height: 25px;
        display: inline-block;
        width: 100%;
        vertical-align: middle;
        border-bottom: 1px solid #f1f1f1;
        .gwd-mw {
          max-width: 160px;
        }
      }

      a:last-of-type {
        border-bottom: none;
      }
    }
  }

  .gwd-rank-list:hover {
    .gwd-rank-addition {
      display: flex;
      flex-direction: column;
    }
  }

  .gwd-rank-list::after {
    content: '';
    position: absolute;
    width: 16px;
    height: 16px;
    background: url(https://cdn.gwdang.com/images/extensions/jdRanking/arrow-right-default.svg);
    right: 3px;
    top: 5px;
    pointer-events: none;
  }

  .gwd-rank-list.gwd-rotate::after {
    transform: rotate(90deg);
  }

  .gwd-rank-list.gwd-rotate:hover::after {
    transform: rotate(270deg);
  }

  .gwd-rank-list:hover::after {
    background: url(https://cdn.gwdang.com/images/extensions/jdRanking/arrow-right-hilighted.svg);
  }
}

.gwd-w217 {
  width: 217px;
  height: 26px;
  background: url(https://cdn.gwdang.com/images/extensions/jdRanking/w217.svg);
}

.gwd-w210, .gwd-w235 {
  width: 210px;
  height: 30px;
  background: url(https://cdn.gwdang.com/images/extensions/jdRanking/w210.svg);
  .gwd-rank-list {
    .gwd-rank-addition {
      width: 140px;
    }
  }
  .gwd-rank-list::after {
    top: 7px;
    background: url(https://cdn.gwdang.com/images/extensions/jdRanking/arrow-right-default-gray.svg);
  }
  .gwd-rank-list a span {
    color: #555555;
    span.gwd-mw {
      max-width: 80px;
    }
  }
}

.gwd-w235 {
  width: 235px;
  height: 23px;
  background: url(https://cdn.gwdang.com/images/extensions/jdRanking/w235.svg);
  .gwd-rank-list a {
    padding-left: 12px;
    span {
      span.gwd-mw {
        max-width: 95px;
      }
    }
  }
  .gwd-rank-list {
    .gwd-rank-addition {
      width: 165px;
    }
  }
  .gwd-rank-list::after {
    right: 6px;
    top: 3px;
  }
}

.gwd-w266 {
  background: url(/bjg/images/rank/jdrankbg.svg);
  width: 266px;
  height: 24px;
  .gwd-rank-list {
    margin-left: 7px;
    .gwd-rank-first {
      span {
        color: @commonRed;
      }
    }
    a span {
      //max-width: 130px;
    }
  }
  .gwd-rank-list:hover {
    .gwd-rank-addition {
      width: 187px;
    }
  }
}
</style>
<script>
export default {
  props: ['data', 'top', 'additionalClass'],
  data() {
    return {
      mt: 0,
      location: location
    }
  },
  mounted() {
    if (this.top) {
      this.mt = this.top
    }
  },
  computed: {
    addition() {
      return this.data.length ? this.data.filter((item, idx) => idx > 0): []
    }
  }
}
</script>